import AuthUser from "@/services/api/authUser";
import $eventHub from "@/services/hubs/eventHub";
import HOME_MAP from "@/services/homeMap";

const safeGuard = ({ path, component, name, beforeEnter, props = false }) => {
  return { path, component, name, beforeEnter, props };
};

const requireUser = (path, component, name, props = false) => {
  const beforeEnter = (to, from, next) => {
    console.log('i am here')
    AuthUser.getUserFromStorage()
      .then(() => {
        console.log('this worked')
        next()
      })
      .catch(() => { 
        console.log('failed stated')
        next("/")
      });
  };

  return safeGuard({ path, component, name, beforeEnter, props });
};

const requireAoFChosen = (path, component, name, props = false) => {
  const beforeEnter = (to, from, next) => {
    if (!AuthUser.isLoggedIn()) {
      next("/");
    } else {
      AuthUser.getUserFromStorage()
        .then(user => {
          if (!user.groups.length) {
            next("/pick-areas-of-focus");
          } else {
            next();
          }
        })
        .catch(() => next("/"));
    }
  };

  return safeGuard({ path, component, name, beforeEnter, props });
};



const requireCoachLicense = (path, component, name, props = false) => {
  const beforeEnter = (to, from, next) => {
    if (!AuthUser.isLoggedIn()) {
      next("/");
    } else {
      AuthUser.getUser(AuthUser.id)
        .then(user => {
          if (!user.has_coach_license) {
            next("/new-user");
          } else {
            const features = user.features.coach_features;
            if (!user.features.exclude.includes(to.name) && (features.includes("all") || features.includes(to.name))) {
              next();
            } else if (from.name === null) {
              next('/daily-exercise');
            } else {
              $eventHub.$emit("upgradeModal");
              next(false);
            }
          }
        })
        .catch(() => next("/"));
    }
  };

  return safeGuard({ path, component, name, beforeEnter, props });
};

const unauthRoute = (path, component, name, props = false) => {
  const beforeEnter = (to, from, next) => {
    if (AuthUser.isLoggedIn()) {
      AuthUser.getUser().then(() => {
        next(AuthUser.features.home);
      });
    } else {
      next();
    }
  };

  return safeGuard({ path, component, name, beforeEnter, props });
};

const logoutBeforeEntry = (path, component, name, props = false) => {
  const beforeEnter = (to, from, next) => {
    AuthUser.logout();
    next();
  };
  return safeGuard({ path, component, name, beforeEnter, props });
};

const authRoute = (path, component, name, props = false) => {
  const beforeEnter = (to, from, next) => {
    if (AuthUser.isLoggedIn()) {
      AuthUser.getUser().then(user => {
        if (!from.name && to.path !== HOME_MAP[user.profile.home]) {
          next(HOME_MAP[user.profile.home])
        } else {
          next();
        }
      }).catch(() => next("/"))
    } else {
      next("/");
    }
  };
  return safeGuard({ path, component, name, beforeEnter, props });
};

const pulseSurvey = (path, component, name, props = false) => {
  const beforeEnter = (to, from, next) => {
    if (!AuthUser.isLoggedIn()) {
      next("/");
    } else {
      next();
    }
  };
  return safeGuard({ path, component, name, beforeEnter, props });
};

export {
  unauthRoute,
  authRoute,
  requireUser,
  requireCoachLicense,
  requireAoFChosen,
  pulseSurvey,
  logoutBeforeEntry,
};
